<template>
  <div>
    <a @click.prevent="() => changeModalName(`timeRequired`)"
      ><small>所要時間表示について</small></a
    >
    <modal
      header="所要時間表示について"
      :opened="modalOpened"
      @close="() => changeModalName('')"
    >
      <p>
        ※駅からの徒歩分数は、道路距離80m=1分として自動算出しております。<br />（端数は切り上げ、信号待ちなどの時間は考慮しておりません。）
      </p>
    </modal>
  </div>
</template>
<script setup>
import { computed, ref } from 'vue';
import Modal from '@component_path/pages/pc/positions/show/common_components/modal/Modal';

const currentModalName = ref('');

const modalOpened = computed(() => currentModalName.value !== '');

const changeModalName = name => (currentModalName.value = name);
</script>
